// The backend owns rollout policy and sends enabled feature keys on login.
// UI code should only use this helper for visibility checks.
export const normalizeEnabledFeatures = (enabledFeatures) => {
  if (Array.isArray(enabledFeatures)) return enabledFeatures;

  if (enabledFeatures && typeof enabledFeatures === "object") {
    return Object.keys(enabledFeatures).filter((featureKey) => enabledFeatures[featureKey] === true);
  }

  return [];
};

export const isFeatureEnabled = (enabledFeatures, featureKey) => (
  normalizeEnabledFeatures(enabledFeatures).includes(featureKey)
);
